module.exports = __webpack_public_path__ + "static/media/twoWomen.0e368eff.jpg";